module.exports = __webpack_public_path__ + "img/blob6.51a63559.svg";